import { Search, Users, Zap, Repeat, Brain, ArrowRight } from "lucide-react";
import { Eyebrow, SectionTitle } from "@/components/web/atoms";
import { Reveal } from "@/components/web/home/primitives";

/* Section 14 — the closing product framework, and the smooth-scroll target
   for the hero's "See How TeamNest Works". */
const STEPS = [
  { icon: Search, title: "Research", desc: "Ask AI.", tone: "ai" },
  { icon: Users, title: "Collaborate", desc: "Work with people.", tone: "brand" },
  { icon: Zap, title: "Do", desc: "Turn answers into actions.", tone: "brand" },
  { icon: Repeat, title: "Automate", desc: "Repeat what works.", tone: "brand" },
  { icon: Brain, title: "Remember", desc: "Build knowledge over time.", tone: "ai" },
];

export default function HowItWorksSection() {
  return (
    <section
      id="how-it-works"
      className="relative py-20 md:py-28 px-5 border-t border-[var(--w-hairline)] bg-[var(--w-bg2)] scroll-mt-20"
      data-testid="home-how-it-works"
    >
      <div className="max-w-6xl mx-auto">
        <Reveal className="max-w-3xl">
          <Eyebrow tone="brand" className="mb-4">How TeamNest works</Eyebrow>
          <SectionTitle>One continuous loop — not five disconnected tools.</SectionTitle>
        </Reveal>

        <div className="mt-12 flex flex-col md:flex-row md:items-center gap-3">
          {STEPS.map((s, i) => {
            const accent = s.tone === "ai" ? "var(--w-ai)" : "var(--w-brand)";
            const tint = s.tone === "ai" ? "var(--w-ai-tint)" : "var(--w-brand-tint)";
            return (
              <Reveal key={s.title} delay={i * 70} className="flex flex-col md:flex-row md:flex-1 md:items-center">
                <div className="flex md:flex-col items-center md:text-center gap-4 md:gap-0 rounded-[16px] border border-[var(--w-hairline)] bg-[var(--w-surface)] p-5 w-full h-full">
                  <span className="w-12 h-12 rounded-2xl flex items-center justify-center md:mb-3 shrink-0" style={{ background: tint }}>
                    <s.icon className="w-5 h-5" style={{ color: accent }} />
                  </span>
                  <div>
                    <div className="text-[16px] font-bold text-[var(--w-text)]">{s.title}</div>
                    <div className="text-[13px] text-[var(--w-text-dim)] mt-0.5">{s.desc}</div>
                  </div>
                </div>
                {i < STEPS.length - 1 && (
                  <div className="hidden md:flex items-center justify-center px-1.5 shrink-0" aria-hidden>
                    <ArrowRight className="w-4 h-4 text-[var(--w-text-mute)]" />
                  </div>
                )}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
